// export const api_url = "http://localhost:8000";
export const api_url = "https://digitalparag.com";
